import http from '@/utils/services/http'

export default {
  registerBanner (banner) {
    return http.post('/api/banner/new', JSON.stringify(banner))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  getBannersList () {
    return http.get('/api/banner/')
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deleteBanner (id) {
    return http.delete('/api/banner/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  uploadFile (data, id) {
    return http.post('/api/banner/' + id + '/upload', data)
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error))
  },
  getBanner (id) {
    return http.get('/api/banner/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateBanner (id, banner) {
    return http.patch('/api/banner/' + id + '/update', banner)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  updateFoto (file, id) {
    return http.post('/api/banner/' + id + '/updateFoto', file, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(result => Promise.resolve(result))
      .catch(error => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/domain/banner/services/banner.js